// extracted by mini-css-extract-plugin
export var body = "_3h-1";
export var bodyPadded = "_3h-2";
export var chevron = "_3h-4";
export var chevronOpen = "_3h-5";
export var header = "_3h-0";
export var icon = "_3h-3";